import React from "react";
import { FaInfoCircle } from "react-icons/fa";

import Modal from "../../components/Modal";

const modalStyle = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modal: {
    width: "92%",
    maxWidth: "520px",
  },
};

function NewOperationGuideModal({ isOpen, onClose, onContinue }) {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal isModalOpen={isOpen} closeModal={onClose} style={modalStyle}>
      <div className="new-operation-guide-modal">
        <h4 className="new-operation-guide-modal__title">
          <FaInfoCircle className="new-operation-guide-modal__icon" aria-hidden />
          Nova operação — orientação
        </h4>

        <p className="new-operation-guide-modal__lead">
          Ao criar manualmente, escolha o tipo de operação com atenção:
        </p>

        <div className="new-operation-guide-modal__card new-operation-guide-modal__card--recommended">
          <strong>Recomendado: Operação em área comum</strong>
          <p>
            Registra <strong>todo o trabalho da máquina</strong>, inclusive fora
            do talhão. Depois você filtra por data, operador ou período na
            própria operação.
          </p>
        </div>

        <div className="new-operation-guide-modal__card">
          <strong>Operação em talhão</strong>
          <p>
            É necessário definir o talhão. Só entra no registro o que acontecer{" "}
            <strong>dentro</strong> desse talhão — o que ocorrer fora{" "}
            <strong>não será contabilizado</strong> nesta operação.
          </p>
        </div>

        <p className="new-operation-guide-modal__note text-muted">
          Máquinas cadastradas já possuem monitoramento automático na lista. Use
          &quot;Nova operação&quot; quando quiser um registro manual adicional.
        </p>

        <div className="new-operation-guide-modal__actions">
          <button
            type="button"
            className="btn btn-default"
            onClick={onClose}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={onContinue}
          >
            Continuar para nova operação
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default NewOperationGuideModal;
